export default "<p>\n  vendor-assessment works!\n</p>\n";